<template>
  <ValidationField
    v-slot="{ field, errors }"
    ref="inputValid"
    v-model="inputValue"
    :name="name"
    as="div"
    :rules="rules"
    :vid="vid"
    :class="{'no-label': !label}"
  >
    <vs-input
      v-bind="field"
      v-model="inputValue"
      :icon="icon"
      :icon-pack="iconPack"
      :label="label"
      :class="className"
      :danger="errors.length > 0"
      :danger-text="errors[0]"
      :disabled="disabled"
      :placeholder="placeholder"
      @blur="onBlur"
    />
  </ValidationField>
</template>

<script>
export default {
  name: 'InputField',
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    name: {
      type: String,
      default: null
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String,
      default: null
    },
    vid: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconPack: {
      type: String,
      default: null
    },
    blurNoError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    inputValue: {
      get () {
        return this.modelValue
      },
      set (newValue) {
        return this.$emit('update:modelValue', newValue)
      }
    },
    className () {
      return {
        'w-full': this.fullWidth
      }
    }
  },
  methods: {
    onBlur () {
      if (this.blurNoError) {
        // フォーカスが外れたらエラーをリセットする
        // 日付選択時にテキストフィールドからフォーカスが外れてのエラー表示を抑制するため
        const provider = this.$refs['inputValid']
        provider.reset()
      }
    }
  }
}
</script>

<style scoped>
.no-label div.vs-component.vs-con-input-label.vs-input.vs-input-primary {
  width: auto;
}
div.vs-component :deep(div.vs-con-input i.vs-icon) {
  top: 0.75rem;
  z-index: 10;
}
</style>
